import { ENVIRONMENT } from 'App';

type LogType = 'log' | 'info' | 'warn' | 'error' | 'table';

/**
 * Used to output console warning messages only during development that should
 * be left permanently in codebase because they warn of potential pitfalls.
 *
 * @param type Type of log.
 * @param args Arguments for log functions.
 */
export const devlog = (type: LogType, ...args: any) => {
  ENVIRONMENT === 'development' && console[type](...args);
};
